/* Author : Nitish Hardeniya */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import {
  TextInput,
  Dropdown,
  Icons,
  Button,
  Dialog,
} from '@techsoftware/happay-widgets';
import NumberFormat from 'react-number-format';
import Grid from '@techsoftware/happay-widgets/Grid';
import PropTypes from 'prop-types';
import Checkbox from '@techsoftware/happay-widgets/Checkbox';
import SignInContainer from '@techsoftware/happay-widgets/SignInContainer';
import HappayLogo from '../../assets/images/happay-logo.svg';
import history from '../../utils/history';
import tncPDF from '../../assets/pdfs/cc_tnc.pdf';
import Locales from '../../constants/locales';
import ValidationPolicy from '../customComponent/validationPolicy';
const SignupConstants = Locales.JSON.signup;

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCodes: [],
      signupData: {
        email: props.auth.invite ? props.auth.invite.email_id : '',
        firstName: '',
        lastName: '',
        countryCode: '',
        phone: '',
        password: '',
        confirmPassword: '',
        fnameValidation: '',
        lnameValidation: '',
        passwordValidation: '',
        cpasswordValidation: '',
        tncValidation: '',
        comparepasswordValidation: '',
        inviteId: props.auth.invite ? props.auth.invite.invite_id : '',
        status: 1,
      },
      passwordValidationList: {
        capital: '',
        special: '',
        length: '',
      },
      openValidationPopup: false,
      openTNC: false,
      tnc: false,
    };
    this.onChange = this.onChange.bind(this);
    this.selectedCountryCode = this.selectedCountryCode.bind(this);
    this.proceedSignup = this.proceedSignup.bind(this);
    this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
  }

  componentDidMount() {
    // get invite details API
    this.props.getCountryCodes();
    const inviteToken = {
      token: this.props.match.params.token,
    };
    if (inviteToken.token) {
      this.props.checkInviteStatus(inviteToken);
    }
  }

  componentDidUpdate(prevProps) {
    const { auth = {} } = this.props;
    if (
      ((prevProps.auth && !prevProps.auth.countryCodes) || !prevProps.auth) &&
      auth.countryCodes
    ) {
      this.updateCountryCode(auth);
    } else if (
      ((prevProps.auth && !prevProps.auth.invite) || !prevProps.auth) &&
      auth.invite
    ) {
      this.updateInviteId(auth);
    }
  }

  updateCountryCode = auth => {
    this.setState({
      countryCodes: auth.countryCodes,
      signupData: {
        ...this.state.signupData,
        countryCode: auth.countryCodes[0].value,
      },
    });
  };

  updateInviteId = auth => {
    const inviteStatus = auth.invite || {};
    this.setState({
      signupData: {
        ...this.state.signupData,
        email: inviteStatus.email_id || '',
        inviteId: inviteStatus.invite_id || '',
        countryCode: inviteStatus.default_ext,
        status: inviteStatus.status,
      },
    });
  };

  _tncPopup = () => {
    this.setState({
      openTNC: !this.state.openTNC,
    });
  };

  onChange(event, value, type) {
    const dataSet = { ...this.state.signupData };
    const { passwordValidationList } = this.state;
    dataSet[type] = value;
    // console.log("NH..",type,value,dataSet)
    if (type === 'password') {
      const regexCapital = /^(?=.*[A-Z]).*$/;
      const regexSpecial = /^(?=.*\W).*$/;
      if (regexCapital.test(value)) {
        passwordValidationList.capital = '';
      } else {
        passwordValidationList.capital =
          SignupConstants.UPPERCASE_IP_VALIDATION;
      }
      if (regexSpecial.test(value)) {
        passwordValidationList.special = '';
      } else {
        passwordValidationList.special =
          SignupConstants.SPECIALCHAR_IP_VALIDATION;
      }
      if (value.length > 6) {
        passwordValidationList.length = '';
      } else {
        passwordValidationList.length =
          SignupConstants.NO_OF_CHARS_IP_VALIDATION;
      }
    }

    this.setState({
      signupData: dataSet,
      passwordValidationList,
      fnameValidation: '',
      lnameValidation: '',
      passwordValidation: '',
      cpasswordValidation: '',
      comparepasswordValidation: '',
      tncValidation: '',
      openValidationPopup: type === 'password' && value,
    });
  }

  selectedCountryCode(value) {
    // console.log(this.state.countryCodes[value].value);
    const dataSet = { ...this.state.signupData };
    dataSet.countryCode = this.state.countryCodes[value].value;
    this.setState({ signupData: dataSet });
  }

  // eslint-disable-next-line consistent-return
  proceedSignup(event) {
    event.preventDefault();
    // console.log(this.state.signupData, 'Final data');
    const finalData = { ...this.state.signupData };
    if (finalData.firstName === '') {
      this.setState({
        fnameValidation: SignupConstants.FIRSTNAME_EMPTY,
      });
      return -1;
    }
    if (finalData.lastName === '') {
      this.setState({
        lnameValidation: SignupConstants.LASTNAME_EMPTY,
      });
      return -1;
    }
    if (finalData.password === '') {
      this.setState({
        passwordValidation: SignupConstants.PASSWORD_EMPTY,
      });
      return -1;
    }
    if (finalData.password.length < 6) {
      this.setState({
        passwordValidation: SignupConstants.PASSWORD_MINCHARS,
      });
      return -1;
    }
    if (finalData.confirmPassword === '') {
      this.setState({
        cpasswordValidation: SignupConstants.CONFIRM_PASSWORD_EMPTY,
      });
      return -1;
    }
    if (finalData.password !== finalData.confirmPassword) {
      this.setState({
        comparepasswordValidation: SignupConstants.PASSWORDS_DIFFERENT,
      });
      return -1;
    }
    if (!this.state.tnc) {
      this.setState({
        tncValidation: SignupConstants.TNC_ERROR,
      });
      return -1;
    }
    const signupPayload = {
      invite_id: finalData.inviteId,
      first_name: finalData.firstName.trim(),
      last_name: finalData.lastName.trim(),
      mobile_extension: finalData.countryCode,
      mobile_number: finalData.phone,
      user_password: finalData.password,
    };

    this.props.sendSignupInfo(signupPayload);
    // history.push('/login');
  }

  // eslint-disable-next-line consistent-return
  matchPassword() {
    const finalData = { ...this.state.signupData };
    if (finalData.confirmPassword === '') {
      this.setState({
        cpasswordValidation: 'Confirm password should not be empty',
      });
      return -1;
    }
    if (finalData.password !== finalData.confirmPassword) {
      this.setState({
        comparepasswordValidation: 'Password & Confirm password must be same',
      });
      return -1;
    }
  }

  onCheckBoxClick() {
    this.setState({ tnc: !this.state.tnc, tncValidation: '' });
  }

  redirectToLogin() {
    history.push('/login');
  }

  render() {
    const {
      email,
      firstName,
      lastName,
      countryCode,
      phone,
      password,
      confirmPassword,
      status,
    } = this.state.signupData;
    if (this.props.auth.signup && this.props.auth.signup.happay_id) {
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          className="happayProduct--container"
        >
          <img src={HappayLogo} alt="happay_logo" />
          <div className="margin-20 align-center">
            <div>{SignupConstants.SIGNUP_SUCCESS}</div>
            <div
              className="hw-link-button-primary"
              onClick={this.redirectToLogin}
            >
              {SignupConstants.LOGIN_LINK}
            </div>
          </div>
        </Grid>
      );
    }
    if (status === 0) {
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          className="happayProduct--container"
        >
          <img src={HappayLogo} alt="happay_logo" />
          <div className="margin-20">{SignupConstants.LINK_EXPIRE} </div>
        </Grid>
      );
    }
    return (
      <Grid
        container
        justify="center"
        direction="row"
        className="happayProduct--container"
      >
        <SignInContainer className="signin-container">
          <Grid item container justify="center">
            <Grid
              item
              xs={24}
              sm={12}
              md={12}
              lg={8}
              xl={8}
              className="signup-form bounceUp"
            >
              <div className="happayProduct--header">
                <img src={HappayLogo} alt="happay_logo" />
                <label htmlFor="account">
                  {SignupConstants.CREATE_ACCOUNT}
                </label>
              </div>
              <form onSubmit={this.proceedSignup}>
                <div className="padding-t-10 padding-b-10 pos-relative">
                  <TextInput
                    floatingLabelText="Email ID"
                    type="email"
                    name="email"
                    disabled
                    onChange={(event, value) =>
                      this.onChange(event, value, 'email')
                    }
                    value={email}
                    customInputParentStyle={{
                      width: '100%',
                      fontSize: '12px',
                    }}
                    clearMargin="true"
                  />
                  <span className="info-icon-phone">
                    <Icons
                      className="primary-green-color"
                      type="tick"
                      size="medium"
                    />
                  </span>
                  {/* Email */}
                </div>
                <div className="padding-t-10 padding-b-10">
                  <TextInput
                    floatingLabelText="First name"
                    required
                    type="text"
                    name="first_name"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'firstName')
                    }
                    value={firstName}
                    hintText="e.g. John"
                    customInputParentStyle={{
                      width: '50%',
                      display: 'inline-block',
                      paddingRight: '10px',
                    }}
                    clearMargin="true"
                    errorType={this.state.fnameValidation ? 'error' : ''}
                    errorText={this.state.fnameValidation}
                  />
                  {/* Firstname */}
                  <TextInput
                    floatingLabelText="Last name"
                    required
                    type="text"
                    name="last_name"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'lastName')
                    }
                    value={lastName}
                    hintText="e.g. Robinson"
                    customInputParentStyle={{
                      width: '50%',
                      display: 'inline-block',
                    }}
                    clearMargin="true"
                    errorType={this.state.lnameValidation ? 'error' : ''}
                    errorText={this.state.lnameValidation}
                  />
                  {/* Lastname */}
                </div>

                <div
                  className="padding-t-10 padding-b-10 pos-relative"
                  style={{ display: 'flex' }}
                >
                  <Dropdown
                    isMultiSelect={false}
                    data={this.state.countryCodes}
                    value={countryCode}
                    selectValueLabel="+1"
                    customDropdownStyle={{
                      width: '40%',
                    }}
                    labelText="Country code"
                    onChange={(event, value) => this.selectedCountryCode(value)}
                    clearMargin="true"
                  />
                  {/* Country code */}
                  <NumberFormat
                    floatingLabelText="Phone number"
                    type="tel"
                    format={SignupConstants.NUMBER_FORMAT}
                    placeholder={SignupConstants.PHONE_PLACEHOLDER}
                    hintText={SignupConstants.PHONE_PLACEHOLDER}
                    value={phone}
                    isNumericString
                    customInput={TextInput}
                    onValueChange={values => {
                      this.onChange({}, values.value, 'phone');
                    }}
                    customInputParentStyle={{
                      width: '60%',
                      marginLeft: '10px',
                    }}
                    clearMargin="true"
                    displayType="input"
                  />
                  {/* <span className="info-icon-phone">
                  <Icons type="info" size="small" />
                </span> */}
                  {/* Mobileno */}
                </div>

                <div className="padding-t-10 padding-b-10 pos-relative">
                  <TextInput
                    floatingLabelText="Password"
                    name="password"
                    type="text"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'password')
                    }
                    value={password}
                    hintText="Enter your password"
                    customInputParentStyle={{
                      width: '100%',
                      fontSize: '12px',
                    }}
                    clearMargin="true"
                    showEyeIcon={password}
                    errorType={this.state.passwordValidation ? 'error' : ''}
                    errorText={this.state.passwordValidation}
                  />
                  <div style={{ position: 'absolute', left: '104%' }}>
                    <ValidationPolicy
                      passwordValidationList={this.state.passwordValidationList}
                      openValidationPopup={this.state.openValidationPopup}
                    />
                  </div>
                  {/* Password */}
                </div>
                <div className="padding-t-10 padding-b-10">
                  <TextInput
                    floatingLabelText="Confirm password"
                    type="password"
                    name="confirm_password"
                    onChange={(event, value) =>
                      this.onChange(event, value, 'confirmPassword')
                    }
                    onBlur={event => {
                      this.matchPassword(event);
                    }}
                    value={confirmPassword}
                    hintText="Confirm your password"
                    customInputParentStyle={{
                      width: '100%',
                      fontSize: '12px',
                    }}
                    clearMargin="true"
                    errorType={
                      this.state.cpasswordValidation ||
                      this.state.comparepasswordValidation
                        ? 'error'
                        : ''
                    }
                    errorText={
                      this.state.cpasswordValidation ||
                      this.state.comparepasswordValidation
                    }
                  />
                  {/* Confirm Password */}
                </div>

                <div className="padding-b-20 left-margin-minus-10">
                  {/* <FormControlLabel
                    control={
                      <CustomCheckbox
                        onChange={() => {
                          this.onCheckBoxClick();
                        }}
                        inputProps={{
                          'aria-label': 'disabled checked checkbox',
                        }}
                        id="uniqueId"
                        labelStyle={{ zIndex: 3 }}
                        value={this.state.tnc}
                      />
                    }
                    label={
                      <label htmlFor="uniqueId">
                        <span className="tnc-style">
                          I accept the{' '}
                          <a
                            href="https://engagementmailimages.s3-ap-southeast-1.amazonaws.com/user_terms_and_conditions.pdf"
                            className="tnc-style-link"
                            target="_blank"
                          >
                            terms and conditions
                          </a>
                        </span>
                      </label>
                    }
                    className="tnc-checkbox"
                  /> */}
                  <Checkbox
                    id="uniqueId"
                    value={this.state.tnc}
                    // icontype="arrow-right"
                    label={
                      <span className="tnc-style">
                        I accept the{' '}
                        <a
                          href="https://engagementmailimages.s3-ap-southeast-1.amazonaws.com/user_terms_and_conditions.pdf"
                          className="tnc-style-link"
                          target="_blank"
                        >
                          terms and conditions
                        </a>
                      </span>
                    }
                    onClick={() => this.onCheckBoxClick()}
                    labelplacement="right"
                    size="medium"
                  />
                  <div className="error-string">{this.state.tncValidation}</div>
                </div>
                <Button
                  type="submit"
                  text="Sign up"
                  variant="primary"
                  size="medium"
                  fullWidth
                  className="button dark noOpac"
                  style={{ width: '100%' }}
                />
              </form>

              <Dialog
                id="signupTerms"
                onBackdropClick={this._tncPopup}
                // aria-labelledby="customized-dialog-title"
                open={this.state.openTNC}
                // maxWidth="md"
                width="60%"
                bodyStyle={{ padding: '30px' }}
                onClose={this._tncPopup}
                title="Terms of Use"
                crossIcon
              >
                <embed src={tncPDF} width="800px" height="660px" />
              </Dialog>

              <div className="privacy-policy-div">
                <span className="privacy-policy">
                  <a href={SignupConstants.PRIVACY_URL} target="_blank">
                    {SignupConstants.PRIVACY_POLICY}
                  </a>
                </span>
                <span className="dot black"></span>
                {Locales.region === 'US' ? (
                  <span className="terms-use" onClick={this._tncPopup}>
                    {SignupConstants.TERMS_OF_USE}
                  </span>
                ) : (
                  <span className="privacy-policy padding-l-10">
                    <a href={SignupConstants.TERMS_URL} target="_blank">
                      {SignupConstants.TERMS_OF_USE}
                    </a>
                  </span>
                )}
              </div>
            </Grid>
          </Grid>
        </SignInContainer>
      </Grid>
    );
  }
}

export default withRouter(Signup);
Signup.propTypes = {
  sendSignupInfo: PropTypes.func,
  getCountryCodes: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  handleCheckBoxClick: PropTypes.func,
  checkInviteStatus: PropTypes.func,
  auth: PropTypes.object,
  match: PropTypes.object,
};
